import overrideDatepickerLocaleDefaults from '../locales/overrideDatepickerLocaleDefaults';

$(() => {
  overrideDatepickerLocaleDefaults();
});
